import ProductCateItem from "./ProductCateItem";

export default ProductCateItem;
